module.exports = __webpack_public_path__ + "static/img/whyy.ad1c876.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/whyy.png
// module id = LH9t
// module chunks = 0